<!--
 * @Author: liuc
 * @Date: 2023-04-11 15:24:24
 * @Description: 登录页面
-->
<template>
    <div class="login-box">
        <img src="../assets/images/login-logo.png" alt="" srcset="">
        <div class="login-content">
            <h1 class="login-title">欢迎登录研效云</h1>
            <el-form :model="user" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item prop="username">
                    <el-input v-model="user.username" placeholder="用户名或注册邮箱"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input v-model="user.password" type="password" placeholder="登录密码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')" v-loading="loginLoading">确认登录</el-button>
                </el-form-item>
            </el-form>
            <p @click="$toast('请前往官网注册！')">注册新用户</p>
        </div>
        <p class="version">v3.2.0.170</p>
    </div>
</template>

<script>
import axios from 'axios';
import { JSEncrypt } from 'jsencrypt';
import Qs from 'qs';
export default {
    name: '',
    data () {
        return {
            loginLoading: false, // 登录按钮loading
            user: {
                username: '',
                password: ''
            },
            rules: {
                username: [
                    { required: true, message: '请输入用户名或注册邮箱', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入登录密码', trigger: 'blur' }
                ]
            },
            // 提示用的options
            options: {
                position: 'bottom', // 'bottom' | 'center',
                duration: '3000'
            }
        };
    },
    components: {
    },
    created () {
    },
    mounted () {
        // 有cookie时自动登录
        if (document.cookie.length > 0) {
            this.autoLogin();
        }
    },
    methods: {
        submitForm (formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let res = {};
                    window.sessionStorage.removeItem('access_token');
                    try {
                        res = await this.$api.Common.getPasswordKey();
                    } catch (error) {
                        this.loading = false;
                        return false;
                    }
                    this.passwordKey = res.data;
                    let encrypt = new JSEncrypt();
                    encrypt.setPublicKey(this.passwordKey);
                    let data = {
                        username: this.user.username,
                        password: this.user.password,
                        grant_type: 'password',
                        scope: 'all',
                        range: 'tenant' // 租户
                    };
                    data.password = encrypt.encrypt(data.password); // 加密后的密码字符串
                    this.loginLoading = true;
                    await axios({
                        url: '/api/auth/oauth/token',
                        method: 'post',
                        data: data,
                        // 将格式转换为form表单格式
                        transformRequest: [
                            function (data) {
                                data = Qs.stringify(data);
                                return data;
                            }
                        ],
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                            Authorization: 'Basic Y2xvdWRzY29wZS1oNTpjbG91ZHNjb3Bl'
                        }
                    }).then(async (res) => {
                        if (res.access_token) {
                            // 存储
                            var exdate = new Date(); // 当前时间
                            exdate.setTime(exdate.getTime() + 3 * 24 * 3600 * 1000);
                            document.cookie = `username=${encodeURIComponent(this.user.username)};expires=${exdate.toGMTString()}`;
                            document.cookie = `password=${encrypt.encrypt(this.user.password)};expires=${exdate.toGMTString()}`;
                            window.sessionStorage.setItem('access_token', JSON.stringify(res.access_token));
                            this.getPushCenter();
                        } else {
                            this.$toast(res.msg, this.options);
                        }
                        this.loginLoading = false;
                    }).catch(() => {
                        this.$toast('登录失败，请重试', this.options);
                        this.loginLoading = false;
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        /**
         * @author: zhaoxf
         * @description: 自动登录
         */
        async autoLogin () {
            let res = {};
            window.sessionStorage.removeItem('access_token');
            try {
                res = await this.$api.Common.getPasswordKey();
            } catch (error) {
                this.loading = false;
                return false;
            }
            this.passwordKey = res.data;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(this.passwordKey);
            var arr = document.cookie.split('; '); // 这里显示的格式需要切割一下自己可输出看下
            for (let i = 0; i < arr.length; i++) {
                let arr2 = arr[i].split('='); // 再次切割
                // 判断查找相对应的值
                if (arr2[0] === 'username') {
                    this.$set(this.user, 'username', decodeURIComponent(arr2[1]));
                };
                if (arr2[0] === 'password') {
                    this.$set(this.user, 'password', arr2[1]);
                };
            }
            let data = {
                username: this.user.username,
                password: this.user.password,
                grant_type: 'password',
                scope: 'all',
                range: 'tenant' // 租户
            };
            await axios({
                url: '/api/auth/oauth/token',
                method: 'post',
                data: data,
                // 将格式转换为form表单格式
                transformRequest: [
                    function (data) {
                        data = Qs.stringify(data);
                        return data;
                    }
                ],
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: 'basic Y2xvdWRzY29wZTpjbG91ZHNjb3Bl'
                }
            }).then(async (res) => {
                if (res.access_token) {
                    window.sessionStorage.setItem('access_token', JSON.stringify(res.access_token));
                    this.getPushCenter();
                } else {

                }
            }).catch((error) => {
                console.log(error);
            });
        },
        async getPushCenter () {
            let res = await this.$api.Common.current();
            this.$store.commit('setUserInfo', res.data);
            const response = await this.$api.LoginManagement.getCurrentUserInfo();
            this.$store.commit('setUserPicture', res.data.icon);
            let comPanys = [];
            if (response.data.authTenants) {
                comPanys = response.data.authTenants.filter(item => {
                    if (item.accountStatus == 1 && (item.tenantStatus == 1 || item.tenantStatus == 2)) {
                        return item;
                    }
                });
            }
            this.$store.commit('setTenantList', comPanys);
            this.$router.push({
                name: '知识中心',
                path: '/KnowledgeCenter'
            });
        },
        resetForm (formName) {
            this.$refs[formName].resetFields();
        }
    }
};
</script>

<style lang="scss" scoped>
.login-box {
    width: 100vm;
    height: 100vh;
    padding: 20px;
    position: relative;
    .login-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 60px;
    }
    h1{
        font-weight: 800;
        margin: 20px;
    }
    /deep/ .el-form{
        .el-form-item__content{
            width: 220px;
            margin-left: 0 !important;
        }
        .el-button{
            width: 100%;
            height: 40px;
            border-radius: 4px;
        }
        .el-form-item{
            margin-bottom: 22px;
        }
    }
    .version {
        width: calc(100% - 40px);
        text-align: center;
        position: absolute;
        bottom: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// ./src/components/Login.vue